import { isMobile, isAndroid, isIOS } from 'react-device-detect';

export interface Message {
  type: string;
  payload?: any;
}

interface Props {
  handleFilteredData: (item: any) => void;
}
export const getReactNativeMessage = ({ handleFilteredData }: Props) => {
  if (!isMobile) {
    return;
  }

  const listener = (event: any) => {
    const parsedData = JSON.parse(event.data);
    if (parsedData?.type === 'gapFilterData') {
      sessionStorage.setItem('gapFilter', parsedData?.payload);
      const gapFilters = sessionStorage.getItem('gapFilter');
      handleFilteredData(gapFilters && JSON.parse(gapFilters));
    } else if (parsedData?.type === 'normalFilterData') {
      sessionStorage.setItem('normalFilterData', parsedData?.payload);
      const normalFiltersData = sessionStorage.getItem('normalFilterData');
      handleFilteredData(normalFiltersData && JSON.parse(normalFiltersData));
    }
  };

  if (window.ReactNativeWebView) {
    if (isAndroid) {
      document.addEventListener('message', listener);
    }
    if (isIOS) {
      window.addEventListener('message', listener);
    }
  }
};

export const sendReactNativeMessage = ({ type, payload }: Message) => {
  if (window.ReactNativeWebView) {
    window.ReactNativeWebView.postMessage(JSON.stringify({ type, payload }));
  }
};

export const addWebViewEventListener = (listener: any) => {
  if (!isMobile) {
    return;
  }

  if (window.ReactNativeWebView) {
    if (isAndroid) {
      document.addEventListener('message', listener);
    }
    if (isIOS) {
      window.addEventListener('message', listener);
    }
  }
};

export const removeWebViewEventListener = (listener: any) => {
  if (!isMobile) {
    return;
  }

  if (window.ReactNativeWebView) {
    if (isAndroid) {
      document.removeEventListener('message', listener);
    }
    if (isIOS) {
      window.removeEventListener('message', listener);
    }
  }
};
